import lru from "./lru";

export default lru;
